import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RankingListItem} from "../../../interfaces/ranking-list-item";
import {Overlayable} from "../../../interfaces/overlayable";

@Component({
  selector: 'brt-ranking-list',
  templateUrl: './ranking-list.component.html',
  styleUrls: ['./ranking-list.component.scss']
})
export class RankingListComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();


  @Input('items') items: RankingListItem[] = [];
  @Input('isOverlay') isOverlay = false;
  @Input('classId') classId = -1;





}
